export default __webpack_public_path__ + "static/report-content-02-bdf89bb4200cf822109c66d51a1e401d.png";